<template>
  <div class="min-w-[180px]">
    <div
      class="flex px-3 lg:py-3 py-2 bg-white items-center shadow-tooltip rounded-lg font-inter"
      :class="tooltipClass"
    >
      <div class="flex flex-col gap-1 flip-tooltip">
        <div v-if="title" class="text-xs lg:leading-[18px] font-semibold text-primary-gray-700">
          {{ title }}
        </div>
        <div class="ltr:text-left rtl:text-right" :class="textClass">
          <div v-if="campus" class="text-primary-grey-light capitalize">{{ campus }}</div>
          <div v-if="text" class="text-primary-gray-500 lg:leading-[18px] capitalize">
            {{ text }}
          </div>
          <div v-if="description" class="text-primary-grey-light capitalize">
            {{ description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: [String, Number], default: '' },
    text: { type: String, default: '' },
    campus: { type: String, default: '' },
    hideIcon: { type: Boolean, default: false },
    description: { type: String, default: '' },
    textExtraSmall: { type: Boolean, default: false },
    direction: { type: String, default: 'right' },
    rightBarTooltip: { type: Boolean, default: false },
    tooltip: { type: String, default: '.tooltip-top' },
  },
  computed: {
    tooltipClass() {
      return [
        `tooltip-${this.direction}`,
        this.rightBarTooltip ? 'rtl:justify-end flip-tooltip-right-bar' : 'flip-tooltip',
        this.tooltip,
      ]
    },
    textClass() {
      return this.textExtraSmall ? 'text-xs' : 'text-xs lg:text-xs'
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip-top {
  &::before {
    position: absolute;
    top: -7px;
    width: 13px;
    height: 13px;
    content: '';
    background: var(--bg-white);
    border-top: 1px solid var(--text-color-info);
    border-left: 1px solid var(--text-color-info);
    transform: rotate(45deg);
  }
  &-right {
    &::before {
      right: 28px;
      @media (max-width: 450px) {
        right: 95px;
      }
    }
  }
  &-left {
    &::before {
      left: 17px;
    }
  }
}
.tooltip-bottom {
  &::before {
    position: absolute;
    bottom: -7px;
    width: 13px;
    height: 13px;
    content: '';
    background: var(--bg-white);
    border-right: 1px solid var(--text-color-info);
    border-bottom: 1px solid var(--text-color-info);
    transform: rotate(45deg);
  }
  &-right {
    &::before {
      right: 28px;
      @media (max-width: 450px) {
        right: 95px;
      }
    }
  }
  &-left {
    &::before {
      left: 17px;
    }
  }
}
.tooltip-shadow {
  box-shadow: 0 4px 6px -2px #10182808;
  &::before {
    margin-left: 12px;
    border: none;
  }
}
.tooltip-border {
  border: none;
}
.tooltip-width {
  min-width: 132px;
}
.tooltip-padding {
  padding: 2px;
  padding-left: 10px;
}
.tooltip-margin {
  margin-left: -10px;
}

body[dir='ltr'] {
  .flip-tooltip-right-bar {
    -ms-filter: fliph; /* IE */
    filter: fliph; /* IE */
    -moz-transform: scaleX(1);
    -webkit-transform: scaleX(1);
    -o-transform: scaleX(1);
    transform: scaleX(1);
  }
}

body[dir='rtl'] {
  .flip-tooltip,
  .flip-tooltip-right-bar {
    -ms-filter: fliph; /* IE */
    filter: fliph; /* IE */
    -moz-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    transform: scaleX(-1);
  }
  .tooltip {
    &::before {
      top: -8px;
    }
  }
}

@media (max-width: 769px) {
  body[dir='ltr'] {
    .tooltip {
      &-right {
        &::before {
          right: 16px;
        }
      }
    }
  }

  body[dir='rtl'] {
    .tooltip {
      &-right {
        &::before {
          top: -7px;
          right: 16px;
        }
      }
    }
  }
}

/* IPAD TO LOWER UPTO 810 PX WIDTH */
@media screen and (max-width: 810px) {
  body[dir='ltr'] {
    .tooltip {
      &-left {
        &::before {
          top: -7px;
          right: 16px;
        }
      }
    }
  }

  body[dir='rtl'] {
    .tooltip {
      &-left {
        &::before {
          left: 15px !important;
        }
      }
    }
  }
}

/* UPTO 600 PX WIDTH */
@media screen and (max-width: 600px) {
  body[dir='rtl'] {
    .tooltip {
      &-left {
        &::before {
          left: 13px !important;
        }
      }
    }
  }
}
</style>

<style lang="scss" module>
.toolTip {
  top: 70px;
  right: 195px;
  z-index: 5;
}
</style>
